(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('SSEnviarSolicitudModalService', SSEnviarSolicitudModalService);

    SSEnviarSolicitudModalService.$inject = ['$uibModal'];

    function SSEnviarSolicitudModalService ($uibModal) {
        var service = {
        	open: open,
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-enviar-solicitud-dialog.html',
                controller: 'EnviarSolicitudController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                     entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    	 return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                     }],
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }        
    }
})();
